import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import highlight from 'scoreboard/components/highlight'

/**
 * Parses a dataset's error properties and returns a formatted error message.
 * @param {Dataset} dataset model
 * @returns {string} the formatted error message
 */
function getErrorMessage(dataset) {
	const errorMessage = dataset.get('errorMessage')
	const errorCode = dataset.get('errorCode')
	const errorArguments = dataset.get('errorArguments') || []

	let error

	// set the initial error to a generic one
	if (!errorMessage && !errorCode) {
		error = i18n.get('datasets.hasError')
	}
	// if we have an error code, that takes precedence
	if (errorCode) {
		const highlightedArgs = _.map(errorArguments, arg => highlight(arg))
		error = i18n.get(errorCode, ...highlightedArgs)
	}
	// if all else fails use the error message constructed on the server
	if (!errorCode && errorMessage) {
		error = _.escape(errorMessage)
	}

	if (errorCode === 'datasets.dataSource.spreadsheet.cellError') {
		const errorDetails = errorArguments[2]
		const args = _(errorArguments)
			.take(2).map(arg => highlight(arg)).value()
		// setting third argument to an empty string so it can be in a new paragraph
		error = i18n.get(errorCode, args[0], args[1], '') +
			'<div class="message-paragraph">' + _.escape(errorDetails) + '</div>'
	}

	return error
}

export default getErrorMessage
getErrorMessage.__filename__ = 'datasets/not-available/get-error-message.js'
